export default __webpack_public_path__ + "static/media/6Klein.51db73f2.jpg";